import React from "react";
import Col from "react-bootstrap/Col";

function SkillsSection({ skill, isScrolled }) {
  return (
    <>
      <Col xs={6} md={3} className={"skillContainer mt-2 mb-2"}>
        <div className={!isScrolled ? "skillBox" : "skillLoad" }>
          <img className={"skillIcon"} src={require(`../../editable-stuff/${skill.name.toLowerCase().replace('.', '').replace('#', '')}.svg`)} />
          <br />
          <p className="lead mb-1 mt-2">{skill.name}</p>
        </div>
      </Col>
    </>
  );
}

function SkillsTab({ skills, isScrolled }) {
  return (
    <>
      {skills.map((skill, index) => (
        <SkillsSection skill={skill}
          isScrolled={isScrolled}
          index={index}
          key={index}
        />
      ))}
    </>
  );
}

export default SkillsTab;
